// src/features/challenge-modals/ui/BaseModal.jsx
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import '@shared/styles/modal/base.css';

export const BaseModal = ({
  show,
  onClose,
  title,
  children,
  width = '500px',
  position = null,
  showCancel = true,
  showConfirm = true,
  confirmText = 'ПОДТВЕРДИТЬ',
  onConfirm = null,
  loading = false,
  danger = false
}) => {
  const modalRef = useRef(null);
  const [targetContainer, setTargetContainer] = useState(null);

  useEffect(() => {
    // Ищем контейнер главной области
    const container = document.getElementById('main-content-area');
    setTargetContainer(container || document.body);
  }, [show]);

  useEffect(() => {
    if (!show) return;

    const scrollContainer = document.getElementById('content-scroll-container');
    if (scrollContainer) {
      const originalOverflowY = scrollContainer.style.overflowY;
      scrollContainer.style.overflowY = 'hidden';
      return () => {
        scrollContainer.style.overflowY = originalOverflowY;
      };
    } else {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [show]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!show) return;

      if (e.key === 'Escape') {
        onClose();
      } else if (e.key === 'Enter' && onConfirm && showConfirm && !loading) {
        onConfirm();
      }
    };

    if (show) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [show, onClose, onConfirm, showConfirm, loading]);

  if (!show) return null;

  const confirmButtonClass = danger ? 'modal-btn-danger' : 'modal-btn-primary';
  const isInsideMainArea = targetContainer && targetContainer.id === 'main-content-area';

  const modalContent = (
    <div 
      className="base-modal-overlay" 
      style={{
        position: isInsideMainArea ? 'absolute' : 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 10000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        ref={modalRef}
        className="context-modal"
        style={{
          minWidth: '280px',
          maxWidth: width,
          width: '100%',
          overflow: 'hidden',
          animation: 'fadeInScale 0.2s ease',
          position: 'relative'
        }}
      >
        <div className="modal-header">
          <h3>{title}</h3>
        </div>

        <div className="modal-content">
          {children}
        </div>

        <div className="modal-footer">
          {showCancel && (
            <button
              className="modal-btn modal-btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              ОТМЕНА
            </button>
          )}

          {showConfirm && onConfirm && (
            <button
              className={`modal-btn ${confirmButtonClass}`}
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? '...' : confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );

  return targetContainer ? createPortal(modalContent, targetContainer) : null;
};

// ========== ДОБАВЛЕН ЭКСПОРТ CONFIRM_MODAL ==========
export const ConfirmModal = ({
  show,
  position,
  title,
  message,
  onClose,
  onConfirm,
  loading,
  bonusPenalty,
  confirmText = 'ДА'
}) => {
  const formattedMessage = bonusPenalty !== undefined && !message.includes('ШТРАФ:')
    ? `${message}\n\nШТРАФ: -${bonusPenalty} ОЧКОВ.`
    : message;

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={title.toUpperCase()}
      position={position}
      width="350px"
      confirmText={confirmText}
      onConfirm={onConfirm}
      loading={loading}
      danger={bonusPenalty > 0}
      showCancel={true}
      showConfirm={true}
    >
      <p style={{ whiteSpace: 'pre-line' }}>{formattedMessage}</p>
    </BaseModal>
  );
};